import React from 'react';

import SPBreadcrumb from 'components/supplier-entry/SPBreadcrumb'
import SPContentWrap from 'components/carRental/base/SPContentWrap';
import SPSupplierEntryPage from 'components/supplier-entry/SPSupplierEntryPage';

interface IPageProps {
	enums?: any;
	permission?: any;
}

const SPPage: React.FC<IPageProps> = props => {
	const { enums, permission } = props;
	return (
    <SPSupplierEntryPage enums={enums}></SPSupplierEntryPage>
	);
};

export default SPPage;
